import { render, staticRenderFns } from "./ModalSertifikat.vue?vue&type=template&id=1c0d6612&"
import script from "./ModalSertifikat.vue?vue&type=script&lang=js&"
export * from "./ModalSertifikat.vue?vue&type=script&lang=js&"
import style0 from "./ModalSertifikat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports